// extracted by mini-css-extract-plugin
export default {"text":"aosbWW","external":"bosbWW","linkColor":"cosbWW","quote":"dosbWW","listMarkdown":"eosbWW"};